import { DefaultResponse } from '@/app/helpers/types';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { AdditionalDataResponse, BriefDataResponse } from './types';
import { getAcceptLang } from '@/app/api/getAcceptLang';

const baseQuery = fetchBaseQuery({
  baseUrl: import.meta.env.VITE_IHAMKOR_API_URL,
  prepareHeaders: (headers) => {
    // headers.set("Authorization", `Basic ${btoa(`${login}:${password}`)}`);
    const lang = getAcceptLang() || 'ru';
    headers.set('Accept-Language', lang);

    headers.set('x-secret', '51fb34db07d2bc62c56ff9c8cdb959f0fb36f32bf96bb3515e86c78a93c2d0dd');
    return headers;
  },
});

export const ihamkorApi = createApi({
  reducerPath: 'ihamkorApi',
  baseQuery,
  endpoints: (builder) => {
    const login = import.meta.env.VITE_IHAMKOR_API_LOGIN;
    const password = import.meta.env.VITE_IHAMKOR_API_PASSWORD;

    return {
      getBriefData: builder.query<DefaultResponse<BriefDataResponse>, string>({
        query: (tin) => ({
          url: '/exec?action=getBriefData',
          method: 'POST',
          body: { tin },
        }),
      }),
      getAdditionalData: builder.query<DefaultResponse<AdditionalDataResponse>, { unique: number }>(
        {
          query: (body) => ({
            url: 'exec?action=getAdditionalData',
            method: 'POST',
            body,
            headers: {
              Authorization: `Basic ${btoa(`${login}:${password}`)}`,
            },
          }),
        }
      ),
    };
  },
});

export const { useGetBriefDataQuery, useGetAdditionalDataQuery } = ihamkorApi;
